import {
    Environment,
    HeaderConfigurationOptions,
    HeaderLocaleOptions,
} from './types';

const HEADER_SERVICE_PATH = '/api/v1/header/aggregate';
const HEADER_SERVICE_PUBLIC_BASE_URL = '/public/api/discover-backend/header';

enum DiscoverBackendHost {
    DEV = 'https://discover-backend-dev.private.zooplus.net',
    PROD = 'https://discover-backend.private.zooplus.net',
}

export function serializeConfigurationOptions(
    configurationOptions: HeaderConfigurationOptions,
): string {
    const queryParamKeys: (keyof HeaderConfigurationOptions)[] = [
        'showCart',
        'showCategories',
        'showMultilanguage',
        'showSearch',
        'searchFlyoutOpen',
    ];

    return queryParamKeys
        .map(
            (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                    configurationOptions[key]!,
                )}`,
        )
        .join('&');
}

export function serializeBaseUrl(
    environment: Environment,
    localeOptions: HeaderLocaleOptions,
): string {
    const { domain, locale } = localeOptions;

    const encodedDomain = encodeURIComponent(domain);
    const encodedLocale = encodeURIComponent(locale);
    const path = `${HEADER_SERVICE_PATH}/${encodedDomain}/${encodedLocale}`;

    const isClientSide = typeof window !== 'undefined';
    if (isClientSide) {
        return `${HEADER_SERVICE_PUBLIC_BASE_URL}${path}`;
    }

    const internalBaseUrl = getDiscoverBackendBaseUrl(environment);
    return `${internalBaseUrl}${path}`;
}

function getDiscoverBackendBaseUrl(environment: Environment): string {
    switch (environment) {
        case 'prod':
        case 'beta':
            return DiscoverBackendHost.PROD;
        case 'dev':
        case 'release':
            return DiscoverBackendHost.DEV;
    }
}
